// filepath: /home/kage/tcm/campus-manager-frontend/src/utils/dateUtils.js
/**
 * Date utilities for event calendar functionality
 */

/**
 * Formats a Date object to ISO date string (YYYY-MM-DD)
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatToISODateString = (date) => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Formats an ISO date string to a display date (Month Day, Year)
 * @param {string} isoDate - ISO format date string
 * @returns {string} Formatted display date
 */
export const formatToDisplayDate = (isoDate) => {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Creates a week schedule array centered around a selected date
 * @param {Date} selectedDate - The central date
 * @param {number} daysOffset - How many days to include before and after
 * @returns {Date[]} Array of date objects
 */
export const getScheduleDates = (selectedDate, daysOffset = 2) => {
  if (!selectedDate) return [];

  const dates = [];
  const start = new Date(selectedDate);
  // start.setDate(start.getDate() - daysOffset);

  for (let i = 0; i < daysOffset * 2 + 1; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    dates.push(date);
  }
  return dates;
};

/**
 * Converts a regular time string to 24-hour format
 * @param {string} timeStr - Time string (e.g., "9:00 AM")
 * @returns {string} 24-hour time (e.g., "09:00")
 */
export const to24HourFormat = (timeStr) => {
  if (!timeStr) return '';

  // If already in 24-hour format
  if (timeStr.indexOf(' ') === -1) {
    return timeStr;
  }

  const [time, period] = timeStr.split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (period.toUpperCase() === 'PM' && hours < 12) {
    hours += 12;
  } else if (period.toUpperCase() === 'AM' && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0'
  )}`;
};

/**
 * Converts 24-hour time format to 12-hour with AM/PM
 * @param {string} timeStr - 24-hour time (e.g., "14:30")
 * @returns {string} 12-hour time (e.g., "2:30 PM")
 */
export const to12HourFormat = (timeStr) => {
  if (!timeStr) return '';

  const [hours, minutes] = timeStr.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;

  return `${hours12}:${String(minutes).padStart(2, '0')} ${period}`;
};

/**
 * Generates a random future date within the specified number of days
 * @param {number} daysAhead - Number of days ahead to consider
 * @returns {Date} Random future date
 */
export const getRandomFutureDate = (daysAhead = 3) => {
  const now = new Date();
  const futureDate = new Date(
    now.getTime() + Math.random() * daysAhead * 24 * 60 * 60 * 1000
  );
  return futureDate;
};
